import styled from "styled-components";
import { theme } from "../../../styles/theme";

export const Container = styled.div`
    width: auto;
    height: auto;

    display: flex;
    align-items: center;

    @media (max-width: 1320px) {
        width: 100%;
        max-width: 100%;
    }
`;

export const Wrapper = styled.div` 
    @media (max-width: 1320px) {
        width: 100%;
        max-width: 100%;
    }
`;

export const CalendaryEvent = styled.div` 
    max-height:  20.625rem;
    min-width: 20.625rem;
    max-width: 20.625rem;
    padding: 1rem 1.5rem;

    gap: 1rem;
    display: flex;
    flex-direction: column;

    border-radius: 1rem;
    background-color: #F8F8F9;

    >div:nth-last-child(1){
        border: none;
        background-color: transparent;

        @media (max-width: 1320px) {
            width: 100%;
        }

        >div:nth-of-type(1){
            border-radius: 0.5rem;
            background-color: #FFFFFF;

            >button:nth-of-type(1){
                background-color: #FFFFFF;

                :hover{
                    background-color: transparent;
                }
            }

            >button:nth-of-type(2){
                cursor: default;
                >span{
                    color: ${theme.colors.gray.Cinza_2};
                    font-weight: 700;
                    font-size: 0.875rem; 
                    line-height: 1.3125rem;
                    font-family: "Lato", Sans-serif;

                    text-transform: capitalize;
                }

                :hover{
                    background-color: transparent;
                }
            }

            >button:nth-of-type(3){
                background-color: #FFFFFF;
                
                :hover{
                    background-color: transparent;
                }
            }
        }

        >div:nth-last-child(1){
            >div>div{
                >button{
                    padding: 1.05rem 0; 
                }
                
                >div{
                    >div:nth-of-type(1){
                        >div>abbr{
                            text-decoration: none;
                        }
                    }
                }

                >div>div:nth-of-type(2) {
                    >button{
                        width: 2.5rem;
                        height: 1.625rem;

                        display: flex;
                        margin-bottom: 0.2rem;
                        align-items: center;
                        justify-content: center;
                    }
                    
                    .react-calendar__tile--active{
                        border-radius: 5rem;
                        color: #FFFFFF !important;
                        background-color: #21262F !important;
                    }
                    
                    .react-calendar__active--today{
                        border-radius: 5rem;
                        color: #589BFF !important;
                        background-color: transparent !important;
                    }
                    
                    .react-calendar__tile-select {
                        color: #FFFFFF; 
                        background-color: #21262F !important; 
                    }

                    .react-calendar-dateNow-focus {
                        color: #FFFFFF !important; 
                        border-radius: 5rem !important;
                        background-color: #589BFF !important; 
                    }

                    .react-calendar__tile:disabled {
                        display: none;
                    }

                    .react-calendar__tile:enabled:hover {
                        background-color: transparent ;
                    }
                }
            }
        }        
    }

    @media (max-width: 1320px) {
        width: 100%;
        max-width: 100%;
    }

    @media (max-width: 900px) {
        width: 100%;
        height: auto;
        max-width: 100%;
        min-width: auto;
        align-items: center;
    }
`;

export const ScheduleAndNewEvent = styled.div` 
    width: 100%;
    height: auto;

    display: flex;
    justify-content: space-between;
`;

export const NewEvent = styled.button` 
    all: unset;
    width: auto;
    height: auto;

    gap: 0.5rem;
    display: flex;
    align-items: center;

    cursor: pointer;

    >img{
        width: 1rem;
        height: auto;
    }

    >p{
        cursor: pointer;
    }
`;

export const ButtonSaved = styled.button`
    all: unset;
    width: 100%;
    height: 1.5rem;
    padding: 0.75rem 1rem;

    display: flex;
    margin-top: 1rem;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    border-radius: 5rem;
    background-color: ${(props) => props.disabled ? theme.colors.disabled.Fundo_Desabilitado : theme.colors.green.Verde_AgroReceita};

    >p{
        cursor: pointer;
        text-align: center;
        color: ${(props) => props.disabled ? theme.colors.disabled.Desabilitado_Medio : theme.colors.white.Branco};
    }
`;

export const ContainerNewCardRight = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    margin-top: 1.5rem;
    align-items: center;
    justify-content: center;
`;

export const ContainerSavedEvent = styled.div`
    width: 100%;
    height: auto;
    max-width: 26.25rem;

    display: flex;
    margin-top: 2rem;

    border-top: 1px solid ${theme.colors.gray.Cinza_10};
`;

export const InputAndButton = styled.div`
    width: 100%;
    height: auto;
    max-width: 26.25rem;

    gap: 0.5rem;
    display: flex;

    @media (max-width: 479px) {
        align-items: center;
        flex-direction: column;
    }
`;

export const InputButton = styled.button`
    all: unset;

    width: auto;
    height: auto;
    padding: 0.5rem 0.75rem;

    display: flex;
    align-items: center;

    cursor: ${(props => (props.isTotvs || props.disabled) ? 'not-allowed' : 'pointer')};

    opacity: ${(props => (props.isTotvs || props.disabled) ? 0.5 : 1)};

    text-align: center;
    text-transform: uppercase;
    color:  ${(props => (props.isTotvs || props.disabled) ? theme.colors.disabled.Desabilitado_Medio : theme.colors.blue.Azul_link)};
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.extraBold};
    font-size: ${theme.typography.fontSize.tagLineM};
    line-height: ${theme.typography.lineHeight.tagLineM};
    letter-spacing: ${theme.typography.letterSpacing.normal};
`;

export const Loading = styled.div`

  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }

  width: 20px;
  height: 20px;
  position: relative;
  margin: auto;
  margin-top: 50px;
  margin-bottom: 50px;

  background-color: transparent;
  border-top: 1px solid #FFF;
  border-bottom: 1px solid #FFF;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;
`;

export const TextArea = styled.textarea`
    width: 100%;
    height: 8.25rem;
    padding: 0.875rem 1rem 0.875rem 1rem;

    border-radius: 0.5rem;
    border: 1px solid ${props => props.hasError ? theme.colors.red.Vermelho_erro : theme.colors.gray.Cinza_7};

    color: ${theme.colors.gray.Cinza_2};
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.regular};
    font-size: ${theme.typography.fontSize.bodyP};
    line-height: ${theme.typography.lineHeight.bodyP};
    letter-spacing: 0px;

    ::placeholder{
        color: ${theme.colors.gray.Cinza_7};
        font-family: ${theme.typography.fontFamily.primary};
        font-weight: ${theme.typography.fontWeight.regular};
        font-size: ${theme.typography.fontSize.bodyP};
        line-height: ${theme.typography.lineHeight.bodyP};
        letter-spacing: 0px;
    }
`;

export const WrapperNewCardRight = styled.div`
    width: 100%;
    height: auto;
    max-width: 26.25rem;

    gap: 1rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
`;